import { DatePicker, Select } from "antd";
import dayjs, { Dayjs } from "dayjs";
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Icon, { ICON_NAME } from "../../../../components/Icon";
import Footer from "../../../../components/Popup/_components/Footer";
import { callEventPopup, openPopup2 } from "../../../../contexts/PopupContext";
import { MAP_ELEMENT } from "../../../../contexts/WorldMapContext/constants";
import { datetime } from "../../../../util/library/datetime";
import { SiteService } from "../../../../util/services/site";
import { selectOpMode } from "../../../../util/store/selectors";
import { getStore } from "../../../../util/store/store";
import { OPERATION_TYPE, propContainer, SHORT_DATETIME_FORMAT } from "../../../../util/varibles/constants";
import { getSundayByKey, renderOpts, showErrorResponse } from "../../../../util/varibles/global";
import { IOperation, ISite, ITaskService, IUnit, TOperation } from "../../../../util/varibles/interface";
import { notify, NotifyCode } from "../../../../util/varibles/message";
import { selectPlan } from "../../constants";
import { planOpActions } from "../../reducer";
import { getTimeByOpMode } from "../../util/function_operation/constants";
import { updateUnitToTask } from "../EditOp/Treatment/constants";
import styles from "./style.module.scss";

let controllerRequest = new AbortController();

interface IProps {
    data: IOperation
}

const Duplicate: React.FC<IProps> = (props) => {
    const { data } = props
    const dispatch = useDispatch();
    const [value, setValue] = useState<Dayjs | null>();
    const [loading, setLoading] = useState(false);
    const opMode = useSelector(selectOpMode)
    const start = getTimeByOpMode[opMode](data.activity_log[0]);
    const { onClose } = callEventPopup();
    const { operation_type } = data.operation;
    const sites = useSelector(selectPlan.sites);
    const valueRef = useRef<{ site_id: string, site_name: string, tasks: ITaskService[] }>({ site_id: data.operation.site_id, site_name: data.operation.site_name, tasks: data.operation.tasks })

    useEffect(() => {
        return () => {
            controllerRequest.abort();
        };
    }, []);

    const handleChangeLocation = (value: ISite) => {
        const { id, name } = value;
        valueRef.current.site_id = id;
        valueRef.current.site_name = name;
        const { tasks } = valueRef.current;
        valueRef.current.tasks = tasks.map(item => ({ ...item, location_id: id, location_name: name, location_type: MAP_ELEMENT.SITE, sub_operations: [] }))
    }

    const handleSubmit = () => {
        const { sub_operations } = data.operation;
        controllerRequest.abort();
        const startTime = datetime(value).startOf('minute').time;
        const newId = selectPlan.indexId(getStore());
        const onGetActivitylog = (newData: typeof data) => {
            controllerRequest = new AbortController();
            dispatch(planOpActions.getActivityLog({
                source: [newData],
                properties: { [newData.operation.id]: { start: startTime } },
                signal: controllerRequest,
                success: (ops) => {
                    const id = Object.keys(ops)[0];
                    const { activity_log } = ops[id];
                    const duration = activity_log[activity_log.length - 1].est_start_time - activity_log[0].est_start_time;
                    const state = getStore();
                    const weeks = selectPlan.weeks(state);
                    const finishTime = getSundayByKey(weeks[weeks.length - 1]).endOf('day').time;
                    const onFinish = () => dispatch(planOpActions.updateOps({ add: ops, isFocus: newData.operation.id }));
                    const newFinish = startTime + duration;
                    if (newFinish > finishTime) {
                        dispatch(planOpActions.lazyLoadingRequest({ key: 'duplicate', duplicateFinishTime: datetime(newFinish).endOf('week').time, action: onFinish }))
                    } else
                        onFinish();
                    onClose?.();
                    setLoading(false)
                },
                failure: (error: any) => {
                    showErrorResponse('Create activity log failed', error)
                    setLoading(false)
                }
            }))
        }


        switch (operation_type) {
            case OPERATION_TYPE.TREATMENT: {
                const params = {
                    start_time: startTime,
                    units: sub_operations.map(({ id }) => ({ id }))
                }
                setLoading(true);
                SiteService.getAmountOfUnit(params)
                    .then((result) => {
                        const { newSubs, units } = sub_operations.reduce((rs: { newSubs: IUnit[], units: Record<string, IUnit> }, item) => {
                            const { fish_amount = 0, avg_weight = 0 } = result.find(sub => sub.id === item.id) || {}
                            const unit = { ...item, fish_amount, avg_weight };
                            rs.units[item.id] = unit;
                            rs.newSubs = [...rs.newSubs, unit];
                            return rs
                        }, { newSubs: [], units: {} })
                        const newData = {
                            ...data,
                            operation: {
                                ...data.operation,
                                id: `${newId}`,
                                round_map: {},
                                tasks: updateUnitToTask(sub_operations, units, data.operation.tasks),
                                sub_operations: newSubs
                            },
                        }
                        onGetActivitylog(newData)
                    })
                    .catch(error => {
                        setLoading(false)
                        showErrorResponse(notify[NotifyCode.E39](['units']), error)
                    })
                break;
            }
            case OPERATION_TYPE.SERVICE: {
                const { site_id, site_name, tasks } = valueRef.current;
                const sub_operations = site_id !== data.operation.site_id ? [] : data.operation.sub_operations;
                const newData = {
                    ...data,
                    operation: { ...data.operation, id: `${newId}`, site_id, site_name, tasks, sub_operations } as TOperation,
                }
                setLoading(true);
                onGetActivitylog(newData)
                break;
            }
        }
    }

    return <>
        <div className={styles.startOld}>
            <Icon icon={ICON_NAME.CALENDAR} />
            <span>{datetime(start).format(SHORT_DATETIME_FORMAT)}</span>
        </div>
        <div className="mb-3">
            <div className={styles.lineLabel}>Start time</div>
            <DatePicker
                {...propContainer}
                className={styles.picker}
                allowClear={false}
                showTime={{ format: 'HH:mm', minuteStep: 15 }}
                disabledDate={(current) => {
                    const now = dayjs();
                    const maxDate = now.add(6, 'month');

                    return (
                        current.isBefore(now.startOf('day')) ||
                        current.isAfter(maxDate.endOf('day'))
                    );
                }}
                format={'DD MMM, HH:mm'}
                placeholder='Select date, time'
                value={value}
                onChange={value => {
                    const minus = Math.ceil(datetime(value).minute / 15) * 15;
                    setValue(datetime(value).set({ minute: minus }).value)
                }}
            />
            <div className={styles.lineLabel}>Location</div>
            {operation_type === OPERATION_TYPE.SERVICE && <Select
                className="w-full mb-3"
                defaultValue={valueRef.current.site_id}
                onChange={(_, opt) => {
                    if (!opt || Array.isArray(opt)) return;

                    handleChangeLocation(opt.root);
                }}
                options={renderOpts<ISite>(sites)}
            />}
        </div>
        <Footer
            ok={{ text: 'Duplicate', disabled: !value, loading, click: handleSubmit }}
            cancel={{ click: onClose }}
        />
    </>;
};

const openPopupDuplicate = (props: IProps) => openPopup2(<Duplicate {...props} />, { modalProps: { title: `Duplicate operation #${props.data.operation.operation_code}`, width: 500, className: styles.popup } })
export default openPopupDuplicate